import * as Styles from './styles';

export const ButtonContainerRight = ({children, ...rest}) => {
    const {width} = rest;
    return (
        <Styles.RightItems width={width}>
            {children}
        </Styles.RightItems>
    )
}